// extracted by mini-css-extract-plugin
export default {"footer":"ZLyhEMXx","bordered":"GOKHapjL"};